import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  AdminLogin,
  InvestorForm,
  NotFound,
  NotificationDetails,
  Notifications,
} from "./screens";
import { PageLoader, ProtectedRoute, ScrollToTop } from "components";
import UserDetails from "./components/admin/userDetails";
import UpdateStore from "./components/admin/UpdateStore";
import Wallet from "./screens/UserDashboard/Wallet";

import {
  AddUpdateBlog,
  AddUpdateStore,
  AddUser,
  AdminDashboard,
  Dividend,
  Stores,
  DividendHistory,
  Transactions,
  Users,
  AdminTransactions,
  DonationShareTransfer,
  DonationShareHistory,
  Blogs,
  AdminWithDrawl,
  WithDrawlRequest,
  AdminInvest,
  AddUpdateUser,
  AdminUsers,
  SubAdminWithDrawl,
  UserDocuments,
  AdminDocuments,
  AdminSendNotification,
  NotificationsHistory,
  AnnualProgress,
  SharePriceHistory,
  DonationTokenHistory,
  DonationTokenTransfer,
  TransactionsOffer,
  Offers,
  AddUpdateOffer,
} from "screens/Admin";

import { LandingPage } from "screens";

import { useDispatch, useSelector } from "react-redux";

import Language from "./components/Language";
import {
  setAdminNotifications,
  setTotalUnseenAdminNotifications,
} from "redux/slices/adminSlice";

import { Suspense } from "react";
import { Live_URL, Local_URL } from "assets/constants";
import { io } from "socket.io-client";
import Logout from "screens/Logout";
import Referral from "screens/Admin/Referral";
import ShareManagement from "screens/Admin/ShareManagement";
import Popup from "screens/Admin/Popup";
import CreatePopup from "screens/Admin/CreatePopup";
import EditPopup from "screens/Admin/EditPopup";
import ViewPopup from "screens/Admin/ViewPopup";




import AddAnnualProgress from "screens/Admin/AddAnnualProgress";
import ManageTickets from "screens/Admin/ManageTickets";
import ManageAllTickets from "screens/Admin/ManageAllTickets";
import TicketDetails from "screens/Admin/TicketDetails";

const socket = io(Live_URL);

const App = () => {
  const dispatch = useDispatch();
  const { adminUser } = useSelector((store) => store.admin);
  socket.on("notification-admin", (data) => {
    if (adminUser) {
      if (adminUser?.id === data?.adminId) {
        dispatch(setAdminNotifications(data?.notifications));
        dispatch(setTotalUnseenAdminNotifications(data?.unSeenNotifications));
      }
    }
  });

  return (
    <>
      <ScrollToTop />
      <Suspense

      // fallback={<PageLoader />}
      >
        <Routes>
          <Route path="/" element={<Language />}>
            <Route path="/:lang">
              <Route index element={<AdminLogin />} />
              <Route index path="admin-login" element={<AdminLogin />} />
              <Route path="logout" element={<Logout />} />
              {/*NOTE:: Admin Private Routes here*/}
              <Route path="admin/" element={<ProtectedRoute isAdmin />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="users" element={<Users />} />
                <Route path="users-document" element={<UserDocuments />} />
                <Route path="notifications" element={<Notifications />} />
                <Route
                  path="notification/:id"
                  element={<NotificationDetails />}
                />
                <Route path="users-document/:id" element={<AdminDocuments />} />

                <Route path="annual-progress" element={<AnnualProgress />} />
                <Route
                  path="annual-progress/add"
                  element={<AddAnnualProgress />}
                />

                <Route path="user-details/:id" element={<UserDetails />} />
                <Route path="stores" element={<Stores />} />
                <Route path="dividend" element={<Dividend />} />
                <Route path="stores/add/" element={<AddUpdateStore />} />
                <Route path="stores/add/:id" element={<AddUpdateStore />} />
                <Route path="store/update/:id" element={<UpdateStore />} />
                <Route path="users/add" element={<AddUser />} />
                <Route path="users/add/:id" element={<AddUpdateUser />} />

                <Route path="transactions" element={<Transactions />} />
                <Route
                  path="admin-transactions"
                  element={<AdminTransactions />}
                />
                <Route
                  path="transactions-offers"
                  element={<TransactionsOffer />}
                />
                <Route path="offers" element={<Offers />} />

                <Route path="offers/add/" element={<AddUpdateOffer />} />
                <Route path="offers/add/:id" element={<AddUpdateOffer />} />

                <Route path="dividend-history" element={<DividendHistory />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="investor" element={<InvestorForm />} />
                <Route path="withdrawl" element={<AdminWithDrawl />} />
                <Route path="admin-invest/:id" element={<AdminInvest />} />
                <Route
                  path="send-notification"
                  element={<AdminSendNotification />}
                />
                 <Route
                  path="share-management"
                  element={<ShareManagement />}
                />
                  <Route
                  path="popup-management"
                  element={<Popup />}
                />
                  <Route
                  path="create-popup"
                  element={<CreatePopup />}
                />
                 <Route path="edit-popup/:id" element={<EditPopup />} />

                 <Route path="view-details-popup/:id" element={<ViewPopup />} />




                <Route
                  path="notification-history"
                  element={<NotificationsHistory />}
                />
                <Route
                  path="share-price-history"
                  element={<SharePriceHistory />}
                />

                <Route path="referral-history" element={<Referral />} />

                <Route
                  path="withdrawl-request"
                  element={<WithDrawlRequest />}
                />
                <Route
                  path="share-transfer"
                  element={<DonationShareTransfer />}
                />
                <Route
                  path="token-transfer"
                  element={<DonationTokenTransfer />}
                />
                <Route
                  path="share-transfer-history"
                  element={<DonationShareHistory />}
                />
                <Route
                  path="token-transfer-history"
                  element={<DonationTokenHistory />}
                />

                <Route path="blog" element={<Blogs />} />
                <Route path="blog/add/:id" element={<AddUpdateBlog />} />
                <Route path="blog/add/" element={<AddUpdateBlog />} />

                <Route path="tickets/" element={<ManageTickets />}>
                  <Route path="manage-all/" element={<ManageAllTickets />} />
                  <Route path=":ticketId/" element={<TicketDetails />} />
                </Route>
              </Route>

              {/*NOTE:: Sub Admin Private Routes here*/}
              <Route path="sub-admin/" element={<ProtectedRoute isSubAdmin />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="blog" element={<Blogs />} />
                <Route path="blog/add/:id" element={<AddUpdateBlog />} />
                <Route path="blog/add/" element={<AddUpdateBlog />} />
                <Route path="stores" element={<Stores />} />
                <Route path="stores/add/" element={<AddUpdateStore />} />
                <Route path="stores/add/:id" element={<AddUpdateStore />} />
                <Route path="store/update/:id" element={<UpdateStore />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="offers" element={<Offers />} />
                <Route path="offers/add/" element={<AddUpdateOffer />} />
                <Route path="offers/add/:id" element={<AddUpdateOffer />} />
                <Route path="withdrawl" element={<SubAdminWithDrawl />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default App;
